import { call, put } from "redux-saga/effects";
import api from "../../services/api";
import { Creators } from "../ducks/identidadeVisual";

export function* fetchIdentidadeVisual({ payload }) {
  try {
    const response = yield call(api.get, `/api/identidade-visual/${payload.empresaId}`);
    yield put(Creators.fetchIdentidadeVisualSuccess(response.data));
  } catch (err) {
    yield put(Creators.fetchIdentidadeVisualFailure(err.message));
  }
}
